























































import Http from "@/api/http/fetch/index";
import EventBus from "@/utils/eventBus";
import dialogTopContent from "@/components/dialog/arrivalTopContent/arrivalTopContent";
import { Component, Emit, Inject, Model } from "vue-property-decorator";
import { Prop, Provide, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import Button from "@/components/button/Button.vue";
import * as types from "@/store/constants/types";
import { sendEvent } from "@/utils/analytics";
import Nav from "@/components/nav/navBar.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import localStorageHelper from "@/localstorage/localstorage";
import BakcPress from "@/utils/backPress";
import SloganView from "./sloganView/SloganView.vue";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import { routerInclude } from "../../utils/routerStackUtil";
import {
  LoginByIns,
  fetchChallenge,
  sendChallenge
} from "@/api/http/ins/insUser";
import { verifyStep } from "@/api/http/ins/insConst";
import { Dialog } from "vant";

@Component({
  components: {
    Button,
    Nav,
    SloganView
  }
})
export default class LoginSelect extends Vue {
  @Getter(types.GETTER_SETTING_DATA) private settingData: any;
  @Getter(types.GETTER_SETTING_FREE_FOLLOWERS_ENABLE)
  private freeFollowersEnable: any;
  @Getter(types.GETTER_NATIVE_FREE_FOLLOWERS_ENABLE)
  private nativeFreeFollowersEnable: any;

  @Mutation(types.LITE_SEARCH_POP_SHOW) private liteSearchPopShow: any;

  @Action(types.LOGIN_BY_FB) private loginByFb: any;

  @Action(types.ROUTER_PUSH) private routerPush: any;

  @Action(types.ADD_USER) private addUser: any;

  @Action(types.ROUTER_GO_BACK) private routerGoBack: any;

  @Action(types.DIALOG_SHOW) private dialogShow: any;

  @Action(types.DIALOG_SHOW_NEWBIE_FREE_FOLLOW)
  private showNewBieFreeFollowDialog: any;

  @Action(types.INITIAL_ROUTE_TO_MAIN_TAB) private gotoMainTab: any;

  private closeDialogSwitch: boolean = false; //facebook退出
  private isNotHandleNotice: boolean = true;

  private isAppInForeground = true;
  private yearTime = new Date().getFullYear();

  get isPostOffer() {
    return GeneralUtilsHelper.isPostOffer;
  }

  get needFreeFollowerAnim() {
    return (
      this.freeFollowersEnable &&
      this.nativeFreeFollowersEnable &&
      this.isAppInForeground
    );
  }

  // Life cycle
  private activated() {}

  private created() {}

  private destroyed() {
    AppLifeCycle.removeListener("splash");
    AppLifeCycle.removeGoBackListener("splash");
  }

  private mounted() {
    if (this.settingData) {
      const { without_login_hint } = this.settingData;
      if (without_login_hint) {
        this.closeDialogSwitch = without_login_hint.close_enabled;
      }
    }

    AppLifeCycle.addListener({
      key: "splash",
      fn: async () => {
        this.isAppInForeground = true;
        this.replaySloganAnim();
      }
    });
    AppLifeCycle.addGoBackListener({
      key: "splash",
      fn: async () => {
        this.isAppInForeground = false;
      }
    });

    BakcPress.listen({
      key: this.$route.name,
      fn: () => {
        this.clickClose();
      }
    });
  }

  private replaySloganAnim() {
    EventBus.$emit("restartSloganAnim", {});
  }

  private clickInsBtn() {
    this.routerPush({
      name: "Login",
      params: { routerTransition: "up", needDialog: true, from: "splash" }
    });
    sendEvent("uia_login_page_click", "login_instagram");
  }

  private retainDialog(fromPage: string = "ins") {
    this.dialogShow({
      title: "Get Started Without Login",
      topIcon: require("@/assets/icons-file/dialog/pic_popup_startedlogin1@3x.png"),
      midContent: `Having trouble logging in? Why not try to <i>search your account instead</i> to get started?`,
      buttons: [
        {
          text: "SEARCH ACCOUNT",
          clickFn: () => {
            this.routerPush({
              name: "Followers",
              params: {
                routerTransition: "up",
                comeFromNotice: false
              }
            });
            this.liteSearchPopShow(true);
          }
        },
        {
          text: "NOT NOW",
          clickFn: () => {}
        }
      ],
      cancelFn: () => {}
    });
  }

  private isPageFromRoot() {
    return this.$route.query.from === "root";
  }

  private exitWithoutLogin() {
    BakcPress.destroy(this.$route.name as any);
    if (this.isPageFromRoot()) {
      this.gotoMainTab();
    } else {
      this.routerGoBack(-1);
    }
  }

  private errorToastOrTips(error: any) {
    console.log("errorToastOrTips:", error);
    Dialog.confirm({
      title: "Login Failed",
      message: "Login Failed",
      confirmButtonText: "Try again",
      showCancelButton: false
    });
  }

  private handleError(error: any) {
    error = error.error;
    if (
      error.hasOwnProperty("two_factor_required") &&
      error.two_factor_required
    ) {
      //=========  双重验证 ===========
      //把帐号密码传过去，让用户可以再次发送验证码：
      console.log("进入双重验证:", error);
      this.routerPush({
        name: "SecurityCode",
        params: {
          twoFactorData: error.two_factor_info,
          // accountText: this.accountText,
          // password: this.password,
          routerTransition: "up"
        }
      });
    } else if (
      (error.hasOwnProperty("error_type") &&
        error.error_type === "checkpoint_challenge_required") ||
      (error.hasOwnProperty("message") &&
        error.message === "challenge_required")
    ) {
      // ======== Chanlenge require ========
      EventBus.$emit("toast-show", {
        type: "loading",
        content: "Logining…",
        duration: "infinite"
      });

      const challengeRequiredUrl = error.challenge.url;
      console.log("进入challengeRequired:", error);
      fetchChallenge(challengeRequiredUrl)
        .then((result: any) => {
          console.log("fetchChallenge result:", result);
          const user_id = result.user_id;
          //选择登陆的验证方式:
          if (result.step_name === verifyStep.select_verify_method) {
            this.routerPush({
              name: "ChallengeRequire",
              params: {
                routerTransition: "up"
              },
              query: {
                userData: JSON.stringify({
                  challengeData: result,
                  challengeUrl: challengeRequiredUrl,
                  userId: user_id
                })
              }
            });
          } else if (
            //为单步骤的验证方式，输入验证码:
            result.step_name === verifyStep.verify_phone_number ||
            result.step_name === verifyStep.verify_code ||
            result.step_name === verifyStep.verify_email
          ) {
            this.routerPush({
              name: "SecurityCode",
              params: {
                challengeUrl: challengeRequiredUrl,
                challengeData: result,
                verifyType: result.step_data.form_type,
                verifyTypeInfo: result.step_data.contact_point,
                userId: user_id,
                routerTransition: "up"
              }
            });
          } else if (result.step_name === verifyStep.delta_login_review) {
            //是我 不是我 本人0
            sendChallenge(challengeRequiredUrl, 0)
              .then((data: any) => {
                console.log("是我本人sendChallenge的结果:", data);
                this.addUser({
                  userId: result.user_id || user_id,
                  userType: "login"
                })
                  .then(() => {})
                  .catch((err: any) => {
                    this.errorToastOrTips(err);
                    console.log("Error:", err);
                  });
              })
              .catch((err: any) => {
                console.log("sendChallenge error: ", err);
                this.errorToastOrTips(err);
              });
          }
        })
        .catch((errMsg: any) => {
          //chanlenge required failed
          this.errorToastOrTips(errMsg);
        })
        .finally(() => {
          EventBus.$emit("toast-hide");
        });
    }
  }

  private clickFbBtn() {
    sendEvent("uia_login_page_click", "login_facebook");
    this.loginByFb()
      .then((result: any) => {})
      .catch((error: any) => {
        if (typeof error === "string" && error.indexOf("ancelled") > -1) {
          if (this.closeDialogSwitch) {
            this.retainDialog();
          }
          return;
        }
        this.handleError(error);
      });
  }

  private clickClose() {
    this.exitWithoutLogin();
    sendEvent("uia_login_page_click", "close_button");
  }

  private clickWithout() {
    this.exitWithoutLogin();
    sendEvent("uia_login_page_click", "quick_start");
  }

  private clickSloganAnimView() {
    sendEvent("uia_welcome_free_followers_click");
    this.showNewBieFreeFollowDialog({
      fromPage: "splash",
      giveupCallback: () => {}
    });
  }
}
